<template>
  <OButton v-bind="$attrs" pure class="absolute right-1 top-1 text-alpha-30" v-on="$listeners">
    <CloseIcon class="w-8 h-8" :class="color" />
  </OButton>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { OButton } from '~/modules/common/components/ui';
import CloseIcon from '~/static/images/icon/close.svg?inline';

export default defineComponent({
  props: {
    color: {
      type: String,
      default: 'text-primary-100',
    },
  },
  components: { CloseIcon, OButton },
});
</script>
